var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel slide carousel-fade"},[_c('div',{staticClass:"carousel-inner"},[_vm._l((_vm.images),function(img,index){return [_c('div',{key:index,class:("carousel-item slideshow-image " + (index === 0 ? 'active' : '')),style:({
          backgroundImage: ("url(" + (_vm.imageWithExtensionSmall(img)) + ")"),
          transitionDuration: (_vm.duration + "s")
        })})]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dcf50ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/PublicationSlideshow.vue
// module id = null
// module chunks = 